<template>
    <div class="roadmap-steps-nav">
        <div class="title-wrapper roadmap-steps-nav-header">
            <div class="title">
                {{$t('roadmap.steps')}}
            </div>
        </div>

        <b-collapse
            class="steps-pages-nav"
            accordion="my-accordion"
            role="tabpanel"
            :visible="true">
            <draggable
                class="list-unstyled steps-nav-items"
                :list="roadmapIn.steps"
                group="pages"
                handle=".steps-drag-handle"
                ghost-class="ghost"
                @change="orderChanged"
                tag="ul">
                <li
                    class="steps-nav-item"
                    v-for="step in roadmapIn.steps"
                    :key="step.id">
                    <a
                        class="steps-nav-link"
                        @click="collapse(step)"
                        :href="`#roadmap-step-${step.id}`">
                        <span class="steps-drag-handle"><i class="fas fa-fw fa-arrows-alt-v"></i></span>
                        <span class="link-title"
                            >{{ step.order }}.
                            {{
                                step.title === '' || step.title === null || !step.title
                                    ? `Stap ${step.order}`
                                    : step.title
                            }}</span
                        >
                    </a>
                </li>
            </draggable>
        </b-collapse>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        name: 'design-2021-roadmap-edit-steps-nav-component',
        props: ['roadmapIn'],
        components: {
            draggable,
        },
        methods: {
            collapse(step) {
                const name = 'roadmap-edit-collapse-' + step.id;
                localStorage.setItem(name, 1);

                this.$root.$emit('bv::toggle::collapse', `roadmap-step-${step.id}`);
            },
            orderChanged() {
                this.$emit('order-changed');
            },
        },
    };
</script>

<style scoped lang="scss">
    .ghost {
        background-color: darken($secondary-background-color, 10%) !important;
    }

    .roadmap-steps-nav {
        .roadmap-steps-nav-header {
            padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
            color: $white;
            background-color: $primary;
            border-radius: $border-radius-content;
        }

        .steps-nav-items {
            .steps-nav-item {
                &:not(:last-child) {
                    .steps-nav-link {
                        border-bottom: 3px dotted $border-color;
                    }
                }
            }

            .steps-nav-link {
                display: flex;
                flex-direction: row;
                align-items: center;
                color: $text-color;
                padding: map-get($grid-gutter-spacing, 'ten');

                .steps-drag-handle {
                    margin-right: map-get($grid-gutter-spacing, 'eight');
                }

                &:hover {
                    cursor: pointer;

                    &,
                    .steps-drag-handle {
                        color: $primary;
                    }
                }
            }
        }
    }
</style>
